import React from "react";
import FounderImage from "../../assets/founders.png";
import DoubleQuotes from "../../assets/Doublequotes.png";
import "./FounderMessage.scss";

const FounderMessage = () => {
	return (
		<div className='Founder-message'>
			<div
				className='Founder-message__text'
				data-aos='fade-right'
				data-aos-once='true'
			>
				<div className='Founder-message__text__doubleQuotes'>
					<img src={DoubleQuotes} alt='double-quote' />
				</div>
				<div className='Founder-message__text__Heading'>
					<h3>Founders' Message</h3>
				</div>
				<div className='Founder-message__text__Content'>
					<p>
						We are solving an unsolved challenge, in an unconquered market, with
						unseen tricks of technology and sales, all to write an untold story
						of success. And in this mission of ours, we need our army to be
						healthy, happy, and hellbent.
					</p>
				</div>
			</div>
			<div
				className='Founder-message__image'
				data-aos='fade-left'
				data-aos-once='true'
			>
				<div>
					<img src={FounderImage} alt='founderImage' />
				</div>
				<div className='Founder-message__image__credits'>
					Picture Credits: Forbes 30 Under 30 India and Asia
				</div>
			</div>
		</div>
	);
};

export default FounderMessage;
